import type { ComponentProps } from 'react';

import * as PopoverPrimitive from '@radix-ui/react-popover';
import { twJoin } from 'tailwind-merge';
import { tv, type VariantProps } from 'tailwind-variants';

export const PopoverClose = PopoverPrimitive.Close;

export const popoverVariants = tv({
  base: 'bg-white rounded-md z-50 p-4 shadow-sm shadow-gray-400',
  variants: {
    animated: {
      true: twJoin(
        'data-[state=closed]:animate-fade-zoom-out data-[state=open]:animate-fade-zoom-in',
      ),
    },
    menulist: {
      true: 'px-0 py-2',
    },
  },
  defaultVariants: {
    animated: true,
    menulist: false,
  },
});

interface PopoverProps
  extends VariantProps<typeof popoverVariants>, ComponentProps<typeof PopoverPrimitive.Root> {
  anchorComponent?: React.ReactNode;
  children: React.ReactNode;
  className?: string;
  contentProps?: ComponentProps<typeof PopoverPrimitive.Content>;
  triggerComponent?: React.ReactNode;
}

export function Popover({
  anchorComponent,
  triggerComponent,
  children,
  contentProps,
  className,
  animated,
  menulist,
  ...props
}: PopoverProps): React.ReactElement {
  return (
    <PopoverPrimitive.Root {...props}>
      {triggerComponent && (
        <PopoverPrimitive.Trigger asChild>{triggerComponent}</PopoverPrimitive.Trigger>
      )}
      {anchorComponent && (
        <PopoverPrimitive.Anchor asChild>{anchorComponent}</PopoverPrimitive.Anchor>
      )}

      <PopoverPrimitive.Portal>
        <PopoverPrimitive.Content
          className={popoverVariants({ animated, menulist, className })}
          {...contentProps}
        >
          {children}
        </PopoverPrimitive.Content>
      </PopoverPrimitive.Portal>
    </PopoverPrimitive.Root>
  );
}
